var _rect, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopTram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C8 5.89543 8.89543 5 10 5H22C23.1046 5 24 5.89543 24 7V19C24 20.1046 23.1046 21 22 21H10C8.89543 21 8 20.1046 8 19V7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 19.2V18.6L17.44 18.7V19.2H14.58V18.7L13.84 18.6V19.2H13.24C13.02 19.2 12.88 19.38 12.88 19.56C12.88 19.82 13.02 19.98 13.24 19.98H18.78C18.96 19.98 19.16 19.82 19.16 19.56C19.16 19.38 18.96 19.2 18.78 19.2H18.18ZM19.18 8.41999C19.08 8.17999 18.94 8.05999 18.7 7.99999C17.84 7.77999 17.22 7.69999 16.42 7.67999V6.97999H17.9C18.1 6.97999 18.26 6.79999 18.26 6.59999C18.26 6.35999 18.1 6.17999 17.9 6.17999H14.14C13.9 6.17999 13.72 6.35999 13.72 6.59999C13.72 6.79999 13.9 6.97999 14.14 6.97999H15.6V7.67999C14.78 7.69999 14.12 7.77999 13.32 7.99999C13.04 8.07999 12.9 8.17999 12.78 8.41999L12.44 9.23999C12.34 9.47999 12.34 9.81999 12.34 10.08V17.28C12.34 17.64 12.58 17.86 12.94 17.92C14.02 18.14 14.96 18.22 16 18.22C17 18.22 17.96 18.14 19.08 17.92C19.42 17.86 19.68 17.64 19.68 17.28V10.08C19.68 9.81999 19.62 9.47999 19.52 9.23999L19.18 8.41999ZM13.52 16.56C13.26 16.56 13.06 16.38 13.06 16.12C13.06 15.84 13.26 15.62 13.52 15.62C13.8 15.62 14 15.84 14 16.12C14 16.38 13.8 16.56 13.52 16.56ZM13.08 9.91999H18.9V14.78C18.14 15 17.06 15.14 16 15.14C14.96 15.14 13.88 14.98 13.08 14.78V9.91999ZM18.54 16.56C18.28 16.56 18.1 16.38 18.1 16.12C18.1 15.84 18.28 15.62 18.54 15.62C18.82 15.62 19.04 15.84 19.04 16.12C19.04 16.38 18.82 16.56 18.54 16.56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopTram);
export default __webpack_public_path__ + "static/media/stop-tram.b5f3a90a826119d9cb6fd405c45ad666.svg";
export { ForwardRef as ReactComponent };